var map = {
	"./favicon.png": "./src/assets/favicon.png",
	"./icons/caret/down.svg": "./src/assets/icons/caret/down.svg",
	"./icons/caret/left.svg": "./src/assets/icons/caret/left.svg",
	"./icons/caret/right.svg": "./src/assets/icons/caret/right.svg",
	"./icons/caret/up.svg": "./src/assets/icons/caret/up.svg",
	"./icons/check/rounded.svg": "./src/assets/icons/check/rounded.svg",
	"./icons/chevron/down.svg": "./src/assets/icons/chevron/down.svg",
	"./icons/chevron/left.svg": "./src/assets/icons/chevron/left.svg",
	"./icons/chevron/right.svg": "./src/assets/icons/chevron/right.svg",
	"./icons/chevron/up.svg": "./src/assets/icons/chevron/up.svg",
	"./icons/clipboard.svg": "./src/assets/icons/clipboard.svg",
	"./icons/close-nav.svg": "./src/assets/icons/close-nav.svg",
	"./icons/close-thin.svg": "./src/assets/icons/close-thin.svg",
	"./icons/close.svg": "./src/assets/icons/close.svg",
	"./icons/copy.svg": "./src/assets/icons/copy.svg",
	"./icons/facebook.svg": "./src/assets/icons/facebook.svg",
	"./icons/hamburger.svg": "./src/assets/icons/hamburger.svg",
	"./icons/instagram.svg": "./src/assets/icons/instagram.svg",
	"./icons/linkedin.svg": "./src/assets/icons/linkedin.svg",
	"./icons/refresh.svg": "./src/assets/icons/refresh.svg",
	"./icons/save.svg": "./src/assets/icons/save.svg",
	"./icons/search.svg": "./src/assets/icons/search.svg",
	"./icons/timer.svg": "./src/assets/icons/timer.svg",
	"./icons/twitter.svg": "./src/assets/icons/twitter.svg",
	"./icons/user.svg": "./src/assets/icons/user.svg",
	"./img/AM-content.jpg": "./src/assets/img/AM-content.jpg",
	"./img/avatar.svg": "./src/assets/img/avatar.svg",
	"./img/bill-and-melinda-gates-foundation.png": "./src/assets/img/bill-and-melinda-gates-foundation.png",
	"./img/business-of-sports-deep-dive-social.jpg": "./src/assets/img/business-of-sports-deep-dive-social.jpg",
	"./img/business-of-sports-deep-dive.png": "./src/assets/img/business-of-sports-deep-dive.png",
	"./img/close-blue.svg": "./src/assets/img/close-blue.svg",
	"./img/close.svg": "./src/assets/img/close.svg",
	"./img/confetti-confirmation.png": "./src/assets/img/confetti-confirmation.png",
	"./img/confused-person.svg": "./src/assets/img/confused-person.svg",
	"./img/data-privacy-deep-dive-social.png": "./src/assets/img/data-privacy-deep-dive-social.png",
	"./img/data-privacy-deep-dive.png": "./src/assets/img/data-privacy-deep-dive.png",
	"./img/davos-deep-dive-social.jpg": "./src/assets/img/davos-deep-dive-social.jpg",
	"./img/davos-deep-dive.png": "./src/assets/img/davos-deep-dive.png",
	"./img/envelope.svg": "./src/assets/img/envelope.svg",
	"./img/facebook-inverse.svg": "./src/assets/img/facebook-inverse.svg",
	"./img/facebook.svg": "./src/assets/img/facebook.svg",
	"./img/future-of-dating-deep-dive-social.jpg": "./src/assets/img/future-of-dating-deep-dive-social.jpg",
	"./img/future-of-dating-deep-dive.png": "./src/assets/img/future-of-dating-deep-dive.png",
	"./img/icon-badge.png": "./src/assets/img/icon-badge.png",
	"./img/icon-bookmark.png": "./src/assets/img/icon-bookmark.png",
	"./img/icon-exclamation.png": "./src/assets/img/icon-exclamation.png",
	"./img/icon-star.png": "./src/assets/img/icon-star.png",
	"./img/instagram-inverse.svg": "./src/assets/img/instagram-inverse.svg",
	"./img/instagram.svg": "./src/assets/img/instagram.svg",
	"./img/large-logo.png": "./src/assets/img/large-logo.png",
	"./img/link.svg": "./src/assets/img/link.svg",
	"./img/linkedin-inverse.svg": "./src/assets/img/linkedin-inverse.svg",
	"./img/linkedin.svg": "./src/assets/img/linkedin.svg",
	"./img/logo.svg": "./src/assets/img/logo.svg",
	"./img/midterms.png": "./src/assets/img/midterms.png",
	"./img/millennial-jobs-deep-dive-social.jpg": "./src/assets/img/millennial-jobs-deep-dive-social.jpg",
	"./img/millennial-jobs-deep-dive.png": "./src/assets/img/millennial-jobs-deep-dive.png",
	"./img/phone-referral-pm.png": "./src/assets/img/phone-referral-pm.png",
	"./img/phone-referral-sports.png": "./src/assets/img/phone-referral-sports.png",
	"./img/plus-box.svg": "./src/assets/img/plus-box.svg",
	"./img/quote.svg": "./src/assets/img/quote.svg",
	"./img/referral-pm-og.jpg": "./src/assets/img/referral-pm-og.jpg",
	"./img/referral-sports-confetti.png": "./src/assets/img/referral-sports-confetti.png",
	"./img/referral-sports-og.jpg": "./src/assets/img/referral-sports-og.jpg",
	"./img/refugee-crisis-social.jpg": "./src/assets/img/refugee-crisis-social.jpg",
	"./img/refugee-crisis.png": "./src/assets/img/refugee-crisis.png",
	"./img/retail-deep-dive-social.jpg": "./src/assets/img/retail-deep-dive-social.jpg",
	"./img/retail-deep-dive.png": "./src/assets/img/retail-deep-dive.png",
	"./img/save.svg": "./src/assets/img/save.svg",
	"./img/search.svg": "./src/assets/img/search.svg",
	"./img/smarter-faster@3x.png": "./src/assets/img/smarter-faster@3x.png",
	"./img/social-default.png": "./src/assets/img/social-default.png",
	"./img/twitter-inverse.svg": "./src/assets/img/twitter-inverse.svg",
	"./img/twitter.svg": "./src/assets/img/twitter.svg",
	"./url/a-on-black.svg": "./src/assets/url/a-on-black.svg",
	"./url/a-on-white.svg": "./src/assets/url/a-on-white.svg",
	"./url/clipboard.svg": "./src/assets/url/clipboard.svg",
	"./url/events.svg": "./src/assets/url/events.svg",
	"./url/newsletter.svg": "./src/assets/url/newsletter.svg",
	"./url/tag.svg": "./src/assets/url/tag.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";